import React, { Component } from "react";
import NavBar from "./components/navbar";
import Router from "./routing/router";

export default class App extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <main className="container" style={{ maxWidth: "100vw" }}>
          <Router />
        </main>
      </div>
    );
  }
}
